"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyQuantityPrecisionRules = exports.getQuantityValidationContext = void 0;
const constants_1 = require("../constants");
const getQuantityValidationContext = (context) => (context ?? {});
exports.getQuantityValidationContext = getQuantityValidationContext;
const countDecimalPlaces = (value) => {
    if (!Number.isFinite(value) || Number.isInteger(value)) {
        return 0;
    }
    const stringValue = value.toString();
    if (stringValue.includes("e")) {
        const fixed = value.toFixed(20).replace(/\.?0+$/, "");
        return (fixed.split(".")[1] || "").length;
    }
    const [, fraction = ""] = stringValue.split(".");
    if (fraction) {
        return fraction.length;
    }
    const fixed = value.toFixed(20).replace(/\.?0+$/, "");
    return (fixed.split(".")[1] || "").length;
};
const quantityPrecisionTest = function quantityPrecisionTest(value) {
    if (value === undefined) {
        return true;
    }
    const { isUnitRegistry } = (0, exports.getQuantityValidationContext)(this.options.context);
    if (isUnitRegistry) {
        if (countDecimalPlaces(value) > constants_1.UNIT_QUANTITY_MAX_DECIMAL_PLACES) {
            return this.createError({ message: constants_1.QUANTITY_MAX_DECIMAL_PLACES });
        }
        return true;
    }
    if (!Number.isInteger(value)) {
        return this.createError({ message: constants_1.INTEGER_REQUIRED });
    }
    return true;
};
const applyQuantityPrecisionRules = (schema) => schema.test("quantityPrecision", quantityPrecisionTest);
exports.applyQuantityPrecisionRules = applyQuantityPrecisionRules;
//# sourceMappingURL=quantityPrecision.js.map